import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@next/core-lib/i18n';

import {
  DairyYieldScanAnswerOption,
  DairyYieldScanCompliment,
  DairyYieldScanImprovement,
} from '../../models/dairy-yield-scan.models';

@Component({
  selector: 'app-dairy-yield-scan-insights',
  templateUrl: './dairy-yield-scan-insights.component.html',
  styleUrls: ['./dairy-yield-scan-insights.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, MatIconModule, TranslatePipe],
})
export class DairyYieldScanInsightsComponent {
  @Input({ required: true }) compliments: readonly DairyYieldScanCompliment[] = [];
  @Input({ required: true }) improvements: readonly DairyYieldScanImprovement[] = [];
  @Input() showComplimentOption = true;

  answerKey(questionKey: string, option: DairyYieldScanAnswerOption): string {
    return `${questionKey}.${this.answerOptionSuffix(option)}`;
  }

  answerOptionKey(option: DairyYieldScanAnswerOption): string {
    return `dairyYieldScan.answerOptions.${this.answerOptionSuffix(option)}`;
  }

  private answerOptionSuffix(option: DairyYieldScanAnswerOption): string {
    switch (option) {
      case 'Improvement':
        return 'improvement';
      case 'Sufficient':
        return 'sufficient';
      case 'Optimal':
        return 'optimal';
    }
  }
}
